<template>
  <b-list-group-item
    button
    @click.stop="$emit('onClick', { id, text })"
    class="d-flex justify-content-between align-items-center my-1 border-0 shadow-sm"
  >
    <label class="m-0">
      <span class="material-icons align-middle small text-main mr-2">
        emoji_objects
      </span>
      {{ text }}
    </label>
    <span @click.stop="$emit('onDelete', { id })" class="material-icons">
      delete_outline
    </span>
  </b-list-group-item>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
    id: {
      type: [String, Number],
      default: 0 || '',
    },
  },
};
</script>
